export default {
  topbar: {
    position: 'fixed',
    top: 0,
    width: '100%',
    backgroundColor: props => {
      if (props.doc) {
        if (props.doc.status === 'draft' || !props.doc.isLatest) {
          return '#455a64';
        }
      }
      return '#00838f';
    },
    color: '#fff',
    fontSize: '16px',
    lineHeight: '56px',
    height: '56px',
    padding: '0 32px',
    zIndex: 19,
  },
  topBarTitle: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: 18,
  },
  body: {
    padding: '60px 0',
  },
  subTitle: {
    padding: '0 10%',
    margin: '8px 12px',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  content: {
    color: 'rgba(0, 0, 0, 0.74)',
    padding: '0 10%',
    borderTop: '1px solid #efefef',
  },
  topbarActions: props => {
    let width = '52px';
    if (props.doc) {
      if (!props.doc.isLatest) {
        width = '52px';
      } else if (props.doc.status === 'draft') {
        width = '365px';
      } else {
        width = '550px';
      }
    }
    return {
      position: 'fixed',
      top: 10,
      right: 16,
      zIndex: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width,
    };
  },
  closeBtn: { cursor: 'pointer', marginLeft: '8px' },
  bottomBar: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    color: '#fff',
    fontSize: '16px',
    height: '56px',
    padding: '0 30%',
    zIndex: 19,
    backgroundColor: '#78909c',
    '&.is-active': {
      backgroundColor: '#00838f',
    },
    justifyContent: 'center',
  },
  flatBtnLabelStyle: {
    textTransform: 'none',
    lineHeight: '30px',
    height: '30px',
    padding: '4px',
    verticalAlign: '',
    top: '-2px',
  },
  applyStepperLabel: {
    color: 'rgba(0, 0, 0, 0.74)',
    marginBottom: '24px',
    fontWeight: 'bold',
  },
};



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/styles.js